import { useCallback, useRef } from 'react';

/** 常に最新のvalueを返すgetterを作る */
export function useGetter<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return useCallback(() => ref.current, []);
}
